module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-agency-cascade-awaiting-48cd882167e46318abdbb106d56c2755.svg";